import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gca_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fmtDateTime = (iso, lang = "de") => {
  if (!iso) return "—";
  return new Date(iso).toLocaleString(lang === "de" ? "de-DE" : "en-US", {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    timeZone: "Europe/Berlin",
  });
};

export const fmtDate = (iso, lang = "de") => {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(lang === "de" ? "de-DE" : "en-US", {
    day: "2-digit", month: "short", year: "numeric",
    timeZone: "Europe/Berlin",
  });
};

export const euro = (n) => `${Number(n).toLocaleString("de-DE")} €`;

// Wandelt einen Axios-Fehler immer in eine anzeigbare Zeichenkette um.
// FastAPI liefert bei 422 ein Array von {loc,msg,...} – das darf NIE direkt
// in React/Toast gerendert werden (führt sonst zum "black screen").
export const apiError = (e, fallback = "Fehler") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x === "string" ? x : x?.msg)).filter(Boolean).join(", ") || fallback;
  if (d && typeof d === "object") return d.msg || fallback;
  return e?.message || fallback;
};

